import { Component, OnInit, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { routerTransition } from '@app/router.animations';
import { KycService } from '@app/core/kyc.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { IMyDpOptions } from 'mydatepicker';
import { getAgeFromDOB } from '../my-needs/my-needs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { QuestionControlService } from '@app/core/question-control.service';
import { QuestionService } from '@app/core/question.service';
import { QuestionBase } from '@app/core/models/question/question-base';
import { Subscription } from 'rxjs/Subscription';
import { detectDevices } from '@app/core/utils';
declare var $;

@Component({
  selector: 'app-save',
  templateUrl: './save.component.html',
  animations: [routerTransition()],
  host: { '[@routerTransition]': '' }
})
export class SaveComponent implements OnInit, OnDestroy {
  @ViewChild('nationalityContainer') nationalityContainer: ElementRef;
  savingText: string;
  age: number;
  isDisabledNextButton = true;
  defaultNationality: string;
  nationalities = [];
  //nationalities = [
  //  { key: 'Afghan', title: 'Afghan' }, 
  //  { key: 'Albanian', title: 'Albanian' },
  //  { key: 'Algerian', title: 'Algerian' },
  //  { key: 'American', title: 'American' },
  //  { key: 'Andorran', title: 'Andorran' },
  //  { key: 'Angolan', title: 'Angolan' },
  //  { key: 'Anguilla', title: 'Anguilla' },
  //  { key: 'Antarctica', title: 'Antarctica' },
  //  { key: 'AntiguaAndBarbuda', title: 'Antigua and Barbuda' },
  //  { key: 'ArcticOcean', title: 'Arctic Ocean' },
  //  { key: 'Argentinian', title: 'Argentinian' },
  //  { key: 'Armenian', title: 'Armenian' },
  //  { key: 'Aromanian', title: 'Aromanian' },
  //  { key: 'Aruban', title: 'Aruban' },
  //  { key: 'AshmoreAndCartierIslands', title: 'Ashmore and Cartier Islands' },
  //  { key: 'AtlanticOcean', title: 'Atlantic Ocean' },
  //  { key: 'Australian', title: 'Australian' },
  //  { key: 'Austrian', title: 'Austrian' },
  //  { key: 'Azerbaijani', title: 'Azerbaijani' },
  //  { key: 'Bahamian', title: 'Bahamian' },
  //  { key: 'Bahraini', title: 'Bahraini' },
  //  { key: 'BakerIsland', title: 'Baker Island' },
  //  { key: 'Bangladeshi', title: 'Bangladeshi' },
  //  { key: 'Barbadian', title: 'Barbadian' },
  //  { key: 'BassasDaIndia', title: 'Bassas da India' },
  //  { key: 'Basotho', title: 'Basotho' },
  //  { key: 'Basques', title: 'Basques' },
  //  { key: 'Belarusian', title: 'Belarusian' },
  //  { key: 'BelgianCongo', title: 'Belgian Congo' },
  //  { key: 'Belgian', title: 'Belgian' },
  //  { key: 'Belizean', title: 'Belizean' },
  //  { key: 'Benin', title: 'Benin' },
  //  { key: 'Bermudian', title: 'Bermudian' },
  //  { key: 'Boers', title: 'Boers' },
  //  { key: 'Bosniak', title: 'Bosniak' },
  //  { key: 'Bhutan', title: 'Bhutan' },
  //  { key: 'Bolivia', title: 'Bolivia' },
  //  { key: 'Borneo', title: 'Borneo' },
  //  { key: 'BosniaAndHerzegovina', title: 'Bosnia and Herzegovina' },
  //  { key: 'Botswana', title: 'Botswana' },
  //  { key: 'BouvetIsland', title: 'Bouvet Island' },
  //  { key: 'Brazilian', title: 'Brazilian' },
  //  { key: 'Breton', title: 'Breton' },
  //  { key: 'British', title: 'British' },
  //  { key: 'BritishGuiana', title: 'British Guiana' },
  //  { key: 'BritishVirginIslands', title: 'British Virgin Island' },
  //  { key: 'Bruneian', title: 'Bruneian' },
  //  { key: 'Bulgarian', title: 'Bulgarian' },
  //  { key: 'MacedonianBulgarian', title: 'Macedonian Bulgarian' },
  //  { key: 'BurkinaFaso', title: 'Burkina Faso' },
  //  { key: 'Burma', title: 'Burma' },
  //  { key: 'Burundian', title: 'Burundian' },
  //  { key: 'Cambodian', title: 'Cambodian' },
  //  { key: 'Cameroonian', title: 'Cameroonian' },
  //  { key: 'Canadian', title: 'Canadian' },
  //  { key: 'CapeVerdean', title: 'Cape Verdean' },
  //  { key: 'Catalan', title: 'Catalan' },
  //  { key: 'CaymanIsland', title: 'Cayman Island' },
  //  { key: 'CentralAfricanRepublic', title: 'Central African Republic' },
  //  { key: 'Chadian', title: 'Chadian' },
  //  { key: 'Chilean', title: 'Chilean' },
  //  { key: 'Chinese', title: 'Chinese' },
  //  { key: 'ChristmasIsland', title: 'Christmas Island' },
  //  { key: 'ClippertonIsland', title: 'Clipperton Island' },
  //  { key: 'CocosIsland', title: 'Cocos Island' },
  //  { key: 'Colombian', title: 'Colombian' },
  //  { key: 'Comorian', title: 'Comorian' },
  //  { key: 'Congolese', title: 'Congolese' },
  //  { key: 'CookIsland', title: 'Cook Island' },
  //  { key: 'CoralSeaIsland', title: 'Coral Sea Island' },
  //  { key: 'CostaRica', title: 'Costa Rica' },
  //  { key: 'CoteDIvoire', title: 'Cote d`Ivoire' },
  //  { key: 'Croatian', title: 'Croatian' },
  //  { key: 'Cuban', title: 'Cuban' },
  //  { key: 'Cypriots', title: 'Cypriots' },
  //  { key: 'TurkishCypriot', title: 'Turkish Cypriot' },
  //  { key: 'CzechRepublic', title: 'Czech Republic' },
  //  { key: 'Czechoslovakia', title: 'Czechoslovakia' },
  //  { key: 'Dane', title: 'Dane' },
  //  { key: 'DemocraticRepublicOfTheCongo', title: 'Democratic Republic of the Congo' },
  //  { key: 'Denmark', title: 'Denmark' },
  //  { key: 'Djibouti', title: 'Djibouti' },
  //  { key: 'DominicansCommonwealth', title: 'Dominicans (Commonwealth)' },
  //  { key: 'DominicanRepublic', title: 'Dominican Republic' },
  //  { key: 'Dutch', title: 'Dutch' },
  //  { key: 'EastTimorese', title: 'East Timorese' },
  //  { key: 'Ecuadorian', title: 'Ecuadorian' },
  //  { key: 'Egyptian', title: 'Egyptian' },
  //  { key: 'ElSalvador', title: 'El Salvador' },
  //  { key: 'Emirati', title: 'Emirati' },
  //  { key: 'English', title: 'English' },
  //  { key: 'EquatorialGuinea', title: 'Equatorial Guinea' },
  //  { key: 'Eritrean', title: 'Eritrean' },
  //  { key: 'Estonian', title: 'Estonian' },
  //  { key: 'Ethiopian', title: 'Ethiopian' },
  //  { key: 'EuropaIsland', title: 'Europa Island' },
  //  { key: 'FalklandIsland', title: 'Falkland Islander' },
  //  { key: 'FaroeIsland', title: 'Faroese' },
  //  { key: 'Finn', title: 'Finn' },
  //  { key: 'FinnishSwedish', title: 'Finnish Swedish' },
  //  { key: 'Fijian', title: 'Fijian' },
  //  { key: 'Filipino', title: 'Filipino' },
  //  { key: 'Finland', title: 'Finland' },
  //  { key: 'FormerYugoslavRepublicOfMacedonia', title: 'Former Yugoslav Republic of Macedonia' },
  //  { key: 'French', title: 'French' },
  //  { key: 'FrenchGuiana', title: 'French Guianese' },
  //  { key: 'FrenchPolynesia', title: 'French Polynesia' },
  //  { key: 'FrenchSouthernAndAntarcticLand', title: 'French Southern and Antarctic Land' },
  //  { key: 'Gabon', title: 'Gabon' },
  //  { key: 'Gambia', title: 'Gambia' },
  //  { key: 'GazaStrip', title: 'Gaza Strip' },
  //  { key: 'Georgian', title: 'Georgian' },
  //  { key: 'German', title: 'German' },
  //  { key: 'BalticGerman', title: 'Baltic German' },
  //  { key: 'Ghanaian', title: 'Ghanaian' },
  //  { key: 'Gibraltar', title: 'Gibraltar' },
  //  { key: 'GloriosoIsland', title: 'Glorioso Island' },
  //  { key: 'Greek', title: 'Greek' },
  //  { key: 'GreekMacedonian ', title: 'Greek Macedonian' },
  //  { key: 'Greenland', title: 'Greenland' },
  //  { key: 'Grenadian', title: 'Grenadian' },
  //  { key: 'Guadeloupe', title: 'Guadeloupe' },
  //  { key: 'Guam', title: 'Guam' },
  //  { key: 'Guatemalan', title: 'Guatemalan' },
  //  { key: 'Guernsey', title: 'Guernsey' },
  //  { key: 'Guinean', title: 'Guinean' },
  //  { key: 'GuineaBissau', title: 'Guinea-Bissau' },
  //  { key: 'Guyanese', title: 'Guyanese' },
  //  { key: 'Haitian', title: 'Haitian' },
  //  { key: 'HeardIslandAndMcDonaldIsland', title: 'Heard Island and McDonald Island' },
  //  { key: 'Honduran', title: 'Honduran' },
  //  { key: 'HongKong', title: 'Hong Kong' },
  //  { key: 'HowlandIsland', title: 'Howland Island' },
  //  { key: 'Hungarian', title: 'Hungarian' },
  //  { key: 'Icelander', title: 'Icelander' },
  //  { key: 'IKiribati', title: 'I-Kiribati' },
  //  { key: 'Indian', title: 'Indian' },
  //  { key: 'IndianOcean', title: 'Indian Ocean' },
  //  { key: 'Indonesian', title: 'Indonesian' },
  //  { key: 'Iranian', title: 'Iranian' },
  //  { key: 'Iraqi', title: 'Iraqi' },
  //  { key: 'Irish', title: 'Irish' },
  //  { key: 'IsleOfMan', title: 'Isle of Man' },
  //  { key: 'Israeli', title: 'Israeli' },
  //  { key: 'Italian', title: 'Italian' },
  //  { key: 'Ivoirian', title: 'Ivoirian' },
  //  { key: 'Jamaican', title: 'Jamaican' },
  //  { key: 'JanMayen', title: 'Jan Mayen' },
  //  { key: 'Japanese', title: 'Japanese' },
  //  { key: 'JarvisIsland', title: 'Jarvis Island' },
  //  { key: 'Jersey', title: 'Jersey' },
  //  { key: 'JohnstonAtoll', title: 'Johnston Atoll' },
  //  { key: 'Jordanian', title: 'Jordanian' },
  //  { key: 'JuanDeNovaIsland', title: 'Juan de Nova Island' },
  //  { key: 'Kazakh', title: 'Kazakh' },
  //  { key: 'Kenyan', title: 'Kenyan' },
  //  { key: 'KerguelenArchipelago', title: 'Kerguelen Archipelago' },
  //  { key: 'KingmanReef', title: 'Kingman Reef' },
  //  { key: 'Kiribati', title: 'Kiribati' },
  //  { key: 'Korean', title: 'Korean' },
  //  { key: 'Kosovar', title: 'Kosovar' },
  //  { key: 'Kurd', title: 'Kurd' },
  //  { key: 'Kuwaiti', title: 'Kuwaiti' },
  //  { key: 'Kyrgyz', title: 'Kyrgyz' },
  //  { key: 'Lao', title: 'Lao' },
  //  { key: 'Latvian', title: 'Latvian' },
  //  { key: 'Lebanese', title: 'Lebanese' },
  //  { key: 'Lesotho', title: 'Lesotho' },
  //  { key: 'Liberian', title: 'Liberian' },
  //  { key: 'Libyan', title: 'Libyan' },
  //  { key: 'Liechtensteiner', title: 'Liechtensteiner' },
  //  { key: 'Lithuanian', title: 'Lithuanian' },
  //  { key: 'Luxembourger', title: 'Luxembourger' },
  //  { key: 'Macao', title: 'Macao' },
  //  { key: 'Macedonian', title: 'Macedonian' },
  //  { key: 'Madagascar', title: 'Madagascar' },
  //  { key: 'Malagasy', title: 'Malagasy' },
  //  { key: 'Malaysian', title: 'Malaysian' },
  //  { key: 'Malawian', title: 'Malawian' },
  //  { key: 'Maldivian', title: 'Maldivian' },
  //  { key: 'Malian', title: 'Malian' },
  //  { key: 'Maltese', title: 'Maltese' },
  //  { key: 'MarshallIsland', title: 'Marshall Island' },
  //  { key: 'Martinique', title: 'Martinique' },
  //  { key: 'Mauritian', title: 'Mauritian' },
  //  { key: 'Mauritiu', title: 'Mauritiu' },
  //  { key: 'Mayotte', title: 'Mayotte' },
  //  { key: 'MediterraneanSea', title: 'Mediterranean Sea' },
  //  { key: 'Mexican', title: 'Mexican' },
  //  { key: 'Micronesia', title: 'Micronesia' },
  //  { key: 'MidwayIsland', title: 'Midway Island' },
  //  { key: 'Moldovan', title: 'Moldovan' },
  //  { key: 'Monaco', title: 'Monaco' },
  //  { key: 'Mongolian', title: 'Mongolian' },
  //  { key: 'Montenegrin', title: 'Montenegrin' },
  //  { key: 'Montserrat', title: 'Montserrat' },
  //  { key: 'Moroccan', title: 'Moroccan' },
  //  { key: 'Mozambique', title: 'Mozambique' },
  //  { key: 'Myanmar', title: 'Myanmar' },
  //  { key: 'Namibian', title: 'Namibian' },
  //  { key: 'Nauru', title: 'Nauru' },
  //  { key: 'NavassaIsland', title: 'Navassa Island' },
  //  { key: 'Nepalese', title: 'Nepalese' },
  //  { key: 'Netherlands', title: 'Netherlands' },
  //  { key: 'NetherlandsAntilles', title: 'Netherlands Antilles' },
  //  { key: 'NewCaledonia', title: 'New Caledonia' },
  //  { key: 'NewZealander', title: 'New Zealander' },
  //  { key: 'Nicaraguan', title: 'Nicaraguan' },
  //  { key: 'Nigerien', title: 'Nigerien' },
  //  { key: 'Nigerian', title: 'Nigerian' },
  //  { key: 'Niue', title: 'Niue' },
  //  { key: 'NorfolkIsland', title: 'Norfolk Island' },
  //  { key: 'NorthKorea', title: 'North Korea' },
  //  { key: 'NorthSea', title: 'North Sea' },
  //  { key: 'NorthernMarianaIsland', title: 'Northern Mariana Island' },
  //  { key: 'Norwegian', title: 'Norwegian' },
  //  { key: 'Oman', title: 'Oman' },
  //  { key: 'PacificOcean', title: 'Pacific Ocean' },
  //  { key: 'Pakistani', title: 'Pakistani' },
  //  { key: 'Palauan', title: 'Palauan' },
  //  { key: 'PalmyraAtoll', title: 'Palmyra Atoll' },
  //  { key: 'Palestinian', title: 'Palestinian' },
  //  { key: 'Panamanian', title: 'Panamanian' },
  //  { key: 'PapuaNewGuinean', title: 'Papua New Guinean' },
  //  { key: 'ParacelIsland', title: 'Paracel Island' },
  //  { key: 'Paraguayan', title: 'Paraguayan' },
  //  { key: 'Peruvian', title: 'Peruvian' },
  //  { key: 'Philippine', title: 'Philippine' },
  //  { key: 'PitcairnIsland', title: 'Pitcairn Island' },
  //  { key: 'Pole', title: 'Pole' },
  //  { key: 'Portuguese', title: 'Portuguese' },
  //  { key: 'PuertoRican', title: 'Puerto Ricans' },
  //  { key: 'Quebecer', title: 'Quebecer' },
  //  { key: 'RepublicOfTheCongo', title: 'Republic of the Congo' },
  //  { key: 'Reunion', title: 'Reunion' },
  //  { key: 'Reunionnai', title: 'R`unionnai' },
  //  { key: 'Romanian', title: 'Romanian' },
  //  { key: 'RossSea', title: 'Ross Sea' },
  //  { key: 'Russian', title: 'Russian' },
  //  { key: 'BalticRussian', title: 'Baltic Russian' },
  //  { key: 'Rwandan', title: 'Rwandan' },
  //  { key: 'SaintHelena', title: 'Saint Helena' },
  //  { key: 'SaintKittsAndNevis', title: 'Saint Kitts and Nevis' },
  //  { key: 'SaintLucia', title: 'Saint Lucia' },
  //  { key: 'SaintPierreAndMiquelon', title: 'Saint Pierre and Miquelon' },
  //  { key: 'SaintVincentAndTheGrenadines', title: 'Saint Vincent and the Grenadines' },
  //  { key: 'Salvadoran', title: 'Salvadoran' },
  //  { key: 'Samoa', title: 'Samoa' },
  //  { key: 'SanMarino', title: 'San Marino' },
  //  { key: 'SaoTomeAndPrincipe', title: 'ao Tome and Principe' },
  //  { key: 'SaudiArabia', title: 'Saudi Arabia' },
  //  { key: 'Scot', title: 'Scot' },
  //  { key: 'Senegalese', title: 'Senegalese' },
  //  { key: 'Serb', title: 'Serb' },
  //  { key: 'SerbiaAndMontenegro', title: 'Serbia and Montenegro' },
  //  { key: 'Seychelle', title: 'Seychelle' },
  //  { key: 'Siam', title: 'Siam' },
  //  { key: 'SierraLeonean', title: 'Sierra Leonean' },
  //  { key: 'Singaporean', title: 'Singaporean' },
  //  { key: 'Sindhian', title: 'Sindhian' },
  //  { key: 'Slovak', title: 'Slovak' },
  //  { key: 'Slovene', title: 'Slovene' },
  //  { key: 'SolomonIsland', title: 'Solomon Island' },
  //  { key: 'Somali', title: 'Somali' },
  //  { key: 'Somalilander', title: 'Somalilander' },
  //  { key: 'SouthAfrican', title: 'South African' },
  //  { key: 'SouthGeorgiaAndTheSouthSandwichIsland', title: 'South Georgia and the South Sandwich Island' },
  //  { key: 'SouthKorea', title: 'South Korea' },
  //  { key: 'SouthernOcean', title: 'Southern Ocean' },
  //  { key: 'Spaniard', title: 'Spaniard' },
  //  { key: 'SpratlyIsland', title: 'Spratly Island' },
  //  { key: 'SriLankan', title: 'Sri Lankan' },
  //  { key: 'StLucian', title: 'St Lucian' },
  //  { key: 'Sudanese', title: 'Sudanese' },
  //  { key: 'Surinamese', title: 'Surinamese' },
  //  { key: 'Svalbard', title: 'Svalbard' },
  //  { key: 'Swaziland', title: 'Swaziland' },
  //  { key: 'Swedes', title: 'Swedes' },
  //  { key: 'Swiss', title: 'Swiss' },
  //  { key: 'Syriac', title: 'Syriac' },
  //  { key: 'Syrian', title: 'Syrian' },
  //  { key: 'Taiwanese', title: 'Taiwanese' },
  //  { key: 'Tajik', title: 'Tajik' },
  //  { key: 'Tanzanian', title: 'Tanzanian' },
  //  { key: 'TasmanSea', title: 'Tasman Sea' },
  //  { key: 'Thai', title: 'Thai' },
  //  { key: 'Tibetan', title: 'Tibetan' },
  //  { key: 'Tobagonian', title: 'Tobagonian' },
  //  { key: 'Togo', title: 'Togo' },
  //  { key: 'Tokelau', title: 'Tokelau' },
  //  { key: 'Tonga', title: 'Tonga' },
  //  { key: 'TrinidadAndTobago', title: 'Trinidad and Tobago' },
  //  { key: 'TromelinIsland', title: 'Tromelin Island' },
  //  { key: 'Tunisian', title: 'Tunisian' },
  //  { key: 'Turk', title: 'Turk' },
  //  { key: 'Turkmenistan', title: 'Turkmenistan' },
  //  { key: 'TurksAndCaicosIsland', title: 'Turks and Caicos Island' },
  //  { key: 'Tuvaluan', title: 'Tuvaluan' },
  //  { key: 'Ugandan', title: 'Ugandan' },
  //  { key: 'Ukrainian', title: 'Ukrainian' },
  //  { key: 'UnitedArabEmirate', title: 'United Arab Emirate' },
  //  { key: 'UnitedKingdom', title: 'United Kingdom' },
  //  { key: 'Uruguayans', title: 'Uruguayans' },
  //  { key: 'USA', title: 'USA' },
  //  { key: 'USSR', title: 'USSR' },
  //  { key: 'Uzbek', title: 'Uzbek' },
  //  { key: 'Vanuatuan', title: 'Vanuatuan' },
  //  { key: 'Venezuelan', title: 'Venezuelan' },
  //  { key: 'Vietnamese', title: 'Vietnamese' },
  //  { key: 'VirginIsland', title: 'Virgin Islands' },
  //  { key: 'WakeIsland', title: 'Wake Island' },
  //  { key: 'WallisAndFutuna', title: 'Wallis and Futuna' },
  //  { key: 'Welsh', title: 'Welsh' },
  //  { key: 'WestBank', title: 'West Bank' },
  //  { key: 'WesternSahara', title: 'Western Sahara' },
  //  { key: 'Yemeni', title: 'Yemeni' },
  //  { key: 'Yugoslavia', title: 'Yugoslavia' },
  //  { key: 'Zaire', title: 'Zaire' },
  //  { key: 'Zambian', title: 'Zambian' },
  //  { key: 'Zimbabwean', title: 'Zimbabwean' }
  //];
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    minYear: 1900,
    maxYear: 2100,
    editableDateField: false,
    markCurrentDay: true,
    width: '336px'
  };
  dob: string;
  saveForm: FormGroup;
  formChangesSubcription: Subscription;
  isMobileOrTablet: any;
  isErrorDate: boolean;
  @HostListener('document:mouseup', ['$event'])
  mouseup(event) {
    if (!this.isMobileOrTablet) {
      this.closeDropdown(event, this.nationalityContainer.nativeElement);
    }
  }

  @HostListener('document:touchend', ['$event'])
  touchend(event) {
    if (this.isMobileOrTablet) {
      this.closeDropdown(event, this.nationalityContainer.nativeElement);
    }
  }

  constructor(
    private kycService: KycService,
    private router: Router,
    private questionService: QuestionService,
    private questionControlService: QuestionControlService) {
  }

  ngOnInit() {
    if (this.kycService.kyc.save.completed) {
      this.router.navigateByUrl('/journey/thank-you');
    }
    this.nationalities = this.kycService.kyc.save.NATIONALITIES
    this.savingText = 'Save';
    const dob = moment(this.kycService.kyc.profile.dob ? this.kycService.kyc.profile.dob : null);
    this.age = this.kycService.kyc.profile.userProfile && this.kycService.kyc.profile.userProfile.age
      ? this.kycService.kyc.profile.userProfile.age
      : null;
    this.dob = this.kycService.kyc.profile.dob;
    this.isErrorDate = this.onErrorDate(this.dob)
    const questionaire = this.questionService.buildSaveQuestionnaire(this.kycService.kyc.save.save);
    const form = this.questionControlService.toFormGroup(questionaire);

    this.saveForm = new FormGroup({
      firstName: new FormControl(form.controls['firstName'].value || '', Validators.required),
      lastName: new FormControl(form.controls['lastName'].value || '', Validators.required),
      email: new FormControl(this.kycService.kyc.profile.userProfile.email || '',
        [Validators.email, Validators.required]),
      dob: new FormControl(this.kycService.kyc.profile.dob
        ? { date: { year: dob.year(), month: dob.month() + 1, day: dob.date() } }
        : null, Validators.required),
      phone: new FormControl(form.controls['phone'].value || '', Validators.required),
      nric: new FormControl(form.controls['nric'].value || ''),
      nationality: new FormControl(form.controls['nationality'].value || '', Validators.required)
    });

    this.formChangesSubcription = this.saveForm.valueChanges.subscribe(formValue => {
      this.kycService.kyc.save.save.forEach((question: QuestionBase<any>) => {
        question.value = formValue[question.key];
      });

      this.kycService.kyc.profile.userProfile.email = this.saveForm.controls['email'].value;
      this.kycService.kyc.profile.dob = this.dob;
      this.kycService.kyc.profile.userProfile.age = this.age;
    });

    this.isMobileOrTablet = detectDevices();
   
  }

  closeDropdown(event, element) {
    if (!element.contains(event.target)) {
      if (element.classList.contains('open')) {
        element.classList.remove('open');
      }
    }
  }

  onCheck(checked: any) {
    if (checked) {
      this.isDisabledNextButton = false;
    } else {
      this.isDisabledNextButton = true;
    }
  }

  onClickNation(nationality: string) {
    if (nationality) {
      this.defaultNationality = nationality;
      this.saveForm.patchValue({
        nationality: nationality
      });
    }
    if ($('#nationalityListWrapper').parent().hasClass('open')) {
      $('#nationalityListWrapper').parent().removeClass('open');
    }
  }

  saveData() {
    if (this.isDisabledNextButton) {
      return;
    }
    if (this.saveForm.valid && !this.isErrorDate) {
      this.savingText = 'Saving...';
      this.kycService.saveKyc(this.kycService.kyc).then(() => {
        this.kycService.kyc.complete();
        this.savingText = 'Save';
        this.router.navigateByUrl('/journey/thank-you');
      }, (err) => {
        alert(err);
      });
    } else {
      this.saveForm.markAsTouched();
    }
  }

  handleInputDate(event) {
    this.dob = moment()
      .year(event.date.year)
      .month(event.date.month - 1)
      .date(event.date.day)
      .toString();
    this.age = getAgeFromDOB(this.dob);
    this.isErrorDate = this.onErrorDate(this.dob)
  }

  ngOnDestroy() {
    this.formChangesSubcription.unsubscribe();
  }

  handleKeyPress(event) {
    if (event.keyCode === 13 || event.which === 13) {
      if (event.target.tabIndex === 6) {
        $(`.input-${event.target.tabIndex}`).blur();
        $('.position-relative').addClass('open');
      } else {
        $(`.input-${event.target.tabIndex + 1}`).focus();
      }
    }
  }

  getNationalityTitle(key) {
    if (!key) {
      return '';
    }
    const currentNational = this.nationalities.filter(item => item.Name === key);

    return currentNational ? currentNational[0].Name : '';
  }

  onNationalityListClick() {
    if (!this.defaultNationality) {
      this.defaultNationality = 'Singaporean';
      this.saveForm.patchValue({
        nationality: this.defaultNationality
      });
      this.scrollToNationality();
    }
    if (!$('#nationalityListWrapper').parent().hasClass('open')) {
      $('#nationalityListWrapper').parent().addClass('open');
    }
  }

  scrollToNationality() {
    const heighOfItem = this.isMobileOrTablet ? 23 : 26;
    const indexOfDefaultNationality = this.nationalities.findIndex(item => item.Name === this.defaultNationality);
    const scrollNationality = document.getElementById('scrollbars');

    setTimeout(() => {
      scrollNationality.scrollTop = heighOfItem * indexOfDefaultNationality - heighOfItem * 2;
    }, 0);
  }
  onErrorDate(dob) {
    const todayDate = new Date(moment(new Date()).format('L'));
    const todayDOB = new Date(moment(dob).format('L'));
    const dobTime = todayDOB.getTime();
    const todayTime = todayDate.getTime()
    return todayTime < dobTime
  }
}



// WEBPACK FOOTER //
// ./src/app/features/save/save.component.ts